import './camp_reg_component.scss'


// WEBPACK FOOTER //
// ./app/components/camp_reg_component/camp_reg.js